<template>
  <div>
    <div class="header">
      <div class="nav">
        <div class="links">
          <router-link to="/" tag="img" class="logo" draggable="false" src="logo.svg" />
          <router-link tag="div" class="btn-nav" to="/">Overview</router-link>
          <router-link tag="div" class="btn-nav" to="/views">Views</router-link>
          <div class="btn-nav" v-on:click="addDeviceModal=1">Add device</div>
          <div class="btn-nav" v-on:click="viewDownloadModal=1">Download</div>
        </div>
        <div class="profile">
          <v-gravatar draggable="false" tabindex="-1" :email="$store.state.account.email" />
          <div class="profile-menu">
            <div>{{$store.state.account.name}}</div>
            <a target="_blank" href="https://auth.infrequent.net/account" class="btn-nav">Account</a>
            <div class="btn-nav" v-on:click="logout()">Sign out</div>
          </div>
        </div>
      </div>
      <div class="flex-side-by-side">
        <div class="details">
          <h1>Device Monitor</h1>
          <p>Manage all your devices</p>
        </div>
      </div>
    </div>
    <div class="modal" v-if="addDeviceModal">
      <div class="modal-body">
        <h3>Add a new device</h3>
        <p>Enter the UUID of the new device.</p>
        <input type="text" v-model="addUUID" class="btn" placeholder="UUID" />
        <div class="action-panel">
          <div class="btn" v-on:click="addDeviceModal=0">Cancel</div>
          <div class="btn main" v-on:click="addDevice()">Add</div>
        </div>
      </div>
    </div>

    <div class="modal" v-if="viewDownloadModal">
      <div class="modal-body">
        <Download/>
        <div class="action-panel">
          <div class="btn" v-on:click="viewDownloadModal = null">Close</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Download from "@/components/parts/Download.vue";
export default {
  name: "Header",
  components: {Download,},
  data() {
    return {
      addDeviceModal: 0,
      addUUID: null,
      viewDownloadModal: null,
    };
  },
  sockets: {},
  methods: {
    logout() {
      this.$store.state.account = null;
      delete localStorage.token;
      this.$router.go("/");
    },
    addDevice: function() {
      var vue = this;
      this.$socket.client.emit("addDevice", vue.addUUID, (error, response) => {
        if (error == "200") {
          vue.$socket.client.emit("getDevices", null, (error, response) => {
            vue.$store.state.stats.devices = response;

            vue.addDeviceModal = 0;
            document.getElementById("Toast1").classList.remove("red");
            document.getElementById("Toast1").classList.remove("hide");
            document.getElementById("Toast1").classList.add("green");
            document.getElementById("Toast1").innerText = "Device added";
            setTimeout(function() {
              document.getElementById("Toast1").classList.add("hide");
            }, 3000);
            vue.$router.push("/device/" + vue.addUUID);
            vue.addUUID = null;
          });
        } else {
          document.getElementById("Toast1").classList.remove("green");
          document.getElementById("Toast1").classList.remove("hide");
          document.getElementById("Toast1").classList.add("red");
          document.getElementById("Toast1").innerText =
            "Could not find the device. Error: " + response;
          setTimeout(function() {
            document.getElementById("Toast1").classList.add("hide");
          }, 3000);
        }
      });
    }
  }
};
</script>
<style scoped lang="scss">
@import "@/assets/styles/global.scss";

div.header {
  user-select: none;
  min-height: 250px;
  height: max-content;
  background-color: var(--main);
  background-image: linear-gradient(45deg, var(--main), #263238);
  color: white;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  display: flex;
  padding: 0 0 2.5rem 0;
  flex-direction: column;
  justify-content: space-between;
  z-index: 100;
  position: relative;
  & > * {
    margin: 0 auto;
    width: 80%;
    max-width: 2000px;
    @media (max-width: 800px) {
      margin-left: 2rem;
      margin-right: 2rem;
      width: calc(100% - 4rem);
    }
    @media (max-width: 500px) {
      margin-left: 1rem;
      margin-right: 1rem;
      width: calc(100% - 2rem);
    }
  }
  div.nav {
    font-size: 0.9rem;
    padding: 1rem 0;
    height: calc(40px + 2rem);
    display: flex;
    justify-content: space-between;
    & > div {
      display: flex;
      &.links {
        padding: 1rem 0;
        margin: -1rem 0;
        overflow-x: auto;
        &::-webkit-scrollbar {
          display: none;
        }
      }
      .logo {
        opacity: 0.8;
        width: 40px;
        margin-right: 1rem;
        cursor: pointer;
        transition: opacity 300ms ease;
        &:hover {
          opacity: 1;
        }
        @media (max-width: 800px) {
          margin-right: 5px;
        }
      }
      & > div.btn-nav {
        background-color: transparent;
        margin: 3px 0;
        box-shadow: none;
        &:not(:last-child) {
          margin-right: 5px;
        }
        flex-grow: 0;
        flex-shrink: 0;
        border-radius: 5px;
        padding: 8px 15px;
        @media (max-width: 800px) {
          font-size: 14px;
          padding: 3px 5px;
          margin: 8px 0;
          &:not(:last-child) {
            margin-right: 0;
          }
        }
        transition: background-color 300ms ease, box-shadow 300ms ease;
        user-select: none;
        cursor: pointer;
        display: flex;
        align-items: center;
        text-align: center;
        height: max-content;
        width: max-content;
        &.router-link-exact-active {
          pointer-events: none;
          cursor: default;
          background-color: rgba(white, 0.1);
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12),
            0 1px 2px rgba(0, 0, 0, 0.24);
        }
        &:hover:not(.router-link-exact-active) {
          background-color: rgba(white, 0.19);
          box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16),
            0 3px 6px rgba(0, 0, 0, 0.23);
        }
      }
      &.profile {
        height: 100%;
        position: relative;
        flex-shrink: 0;
        margin-left: 5px;
        img {
          height: 40px;
          width: 40px;
          border-radius: 50%;
          object-fit: cover;
          cursor: pointer;
          background-color: rgba(white, 0.1);
          transition: background-color 300ms ease, box-shadow 300ms ease;
          &:hover,
          &:focus {
            background-color: rgba(white, 0.19);
            box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19),
              0 6px 6px rgba(0, 0, 0, 0.23);
          }
        }
        img:focus ~ .profile-menu,
        .profile-menu:focus,
        &:focus-within .profile-menu,
        &:focus .profile-menu {
          opacity: 1;
          pointer-events: all;
        }
        .profile-menu {
          opacity: 0;
          pointer-events: none;
          transition: opacity 300ms ease;
          position: absolute;
          top: calc(0.5rem + 100%);
          right: 0;
          min-width: 180px;
          border-radius: 5px;
          background-color: rgba(black, 0.6);
          backdrop-filter: blur(10px);
          color: rgba(white, 0.8);
          min-height: 100px;
          box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16),
            0 3px 6px rgba(0, 0, 0, 0.23);
          z-index: 100;
          div,
          a {
            padding: 15px 15px;
            min-width: max-content;
            width: 100%;
            &:not(:last-child) {
              border-bottom: 1px solid rgba(white, 0.15);
            }
            &.btn-nav {
              padding: 10px 15px;
              font-size: 0.8rem;
              cursor: pointer;
              transition: background-color 300ms ease;
              &:hover {
                background-color: rgba(white, 0.05);
              }
            }
          }
        }
      }
    }
    a {
      color: inherit;
      text-decoration: none;
      display: block;
    }
  }
  .details {
    padding: 0 1.5rem;
    h1 {
      margin: 0;
    }
    p {
      margin: 0.6rem 0 0.6rem 0;
      font-size: 1.2rem;
    }
  }
  .flex-side-by-side {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    flex-wrap: wrap;
  }
  .online-supporters {
    margin-left: auto;
    h4 {
      margin-bottom: 10px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .supporters {
      display: flex;
      flex-direction: row-reverse;
      justify-content: flex-start;
      margin-right: 5px;
      & > * {
        &.me {
          display: none;
        }
        margin-right: -5px;
        height: 40px;
        width: 40px;
        border-radius: 50%;
        object-fit: cover;
        cursor: default;
        background-color: rgba(white, 0.1);
        transition: background-color 300ms ease, box-shadow 300ms ease;
        &:hover {
          background-color: rgba(white, 0.19);
          box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19),
            0 6px 6px rgba(0, 0, 0, 0.23);
        }
        animation: entrence 800ms forwards;
        @keyframes entrence {
          0% {
            transform: scale(0);
          }
          60% {
            transform: scale(1.2);
          }
          100% {
            transform: scale(1);
          }
        }
      }
    }
  }
}

</style>
